import './index.scss';
import { useTranslation } from 'react-i18next';
import { useEffect, useRef, useState } from 'react';
import { Image } from '../../../assets';
import SignatureCanvas from 'react-signature-canvas';
import PayPalCheckoutButton from '../../../components/common/paypalCheckoutButton';
import { userInfo } from '../../../redux/slice';
import { useSelector } from 'react-redux';
import { Modal } from 'antd';
import { get } from '../../../util/request';


export default Submission; function Submission({ handleSignatureSave, TaxFilingQuestionnaire }) {
    const { t } = useTranslation();
    const signatureCanvasRef = useRef(null);
    const viewOnly = (TaxFilingQuestionnaire?.Status?.toLowerCase() !== '' && TaxFilingQuestionnaire?.Status?.toLowerCase() !== 'new') || (sessionStorage?.getItem('taxAction') === 'Pay');
    const user = useSelector(userInfo);

    const width = 600;
    const height = 700;
    const left = window.screenX + (window.outerWidth - width) / 2;
    const top = window.screenY + (window.outerHeight - height) / 2;

    const [bankTransferSteps, setBankTransferSteps] = useState({});
    const [bankTransferNotes, setBankTransferNotes] = useState('');

    const [taxDisclaimer, setTaxDisclaimer] = useState({});
    const [taxDisclaimerNotes, setTaxDisclaimerNotes] = useState('');


    const bankTransferRegion = ['HK', 'TW', 'DB', 'CN'];

    const previewDetail = JSON.parse(sessionStorage.getItem('previewDetail'));

    const handleClear = () => {
        signatureCanvasRef.current.clear();
        handleSignatureSave(true, '');
    };


    const handleEnd = () => {
        handleSignatureSave(signatureCanvasRef.current.isEmpty(), signatureCanvasRef.current.isEmpty() ? '' : signatureCanvasRef.current.getTrimmedCanvas().toDataURL('image/png').split(',')[1]);
    }

    const formatDate = (value) =>
        new Intl.DateTimeFormat('fr-CA', {
            year: 'numeric', month: '2-digit', day: '2-digit'

        }).format(value).replace(/-/g, '%2F');

    const formatNumber = (value) => {
        if (value) {
            return Number(value).toLocaleString()
        } else {
            return 0
        }

    }

    const handlePayNowModal = () => {
        const amount = TaxFilingQuestionnaire?.TotalPayNowAmount;
        const expiry = new Date(TaxFilingQuestionnaire.DueDate) < new Date() ? formatDate(new Date()) + '%2011%3A59' : formatDate(new Date(TaxFilingQuestionnaire.DueDate)) + '%2011%3A59';
        const refId = `TaxFee-${TaxFilingQuestionnaire.TaxFilingYear}-${TaxFilingQuestionnaire.CustomerID}`;
        const url = `https://www.sgqrcode.com/paynow?mobile=&uen=199602425R&editable=0&amount=${amount}&expiry=${expiry}&ref_id=${refId}&company=Walton%20Global%20Pte%20ltd`;
        window.open(
            url,
            "PaymentWindow",
            `width=${width},height=${height},left=${left},top=${top},` +
            `resizable=yes,scrollbars=yes,toolbar=no,location=no,status=no,menubar=no`
        );
    }

    useEffect(() => {
        setTimeout(() => {
            window.scrollTo(0, 0);
        }, 100);
        getBankTransferSteps();
        getTaxDisclaimer();
    }, []);




    const getBankTransferSteps = async () => {
        let params = {
            accessToken: user.accessToken,
            userId: user.userId
        };
        const data = await get('/taxQuestionnaire/bankTransfer/steps', params);
        if (data) {
            setBankTransferSteps(data);
        }
    }

    const getTaxDisclaimer = async () => {
        let params = {
            accessToken: user.accessToken,
            userId: user.userId
        };
        const data = await get('/taxQuestionnaire/disclaimer', params);
        if (data) {
            setTaxDisclaimer(data);
        }
    }

    useEffect(() => {
        let content = '';
        let disclaimer = '';
        switch (window.localStorage.lang) {
            case "Traditional Chinese":
            case "zh_HK":
                content = bankTransferSteps?.contentTC;
                disclaimer = taxDisclaimer?.contentTC;
                break;
            case "Simplified Chinese":
            case "zh_CN":
                content = bankTransferSteps?.contentSC;
                disclaimer = taxDisclaimer?.contentSC;
                break;
            case "Japanese":
            case "jp":
                content = bankTransferSteps?.contentJA;
                disclaimer = taxDisclaimer?.contentJA;
                break;
            default:
                content = bankTransferSteps?.contentEN;
                disclaimer = taxDisclaimer?.contentEN;
                break;
        }
        setBankTransferNotes(content);
        setTaxDisclaimerNotes(disclaimer);
    }, [window.localStorage.lang, bankTransferSteps, taxDisclaimer]);

    return (
        <>
            <div id='stepper-projects-exited-div'>
                <div className='row stepper-projects-exited-content col-md-12'>
                    <div className='col-md-6'>
                        <div className='row input-row'>
                            <div className='col-md-12 projects-exited-details'>
                                <span className='fee-title'>{t('Fees and Charges')}</span>
                            </div>
                        </div>
                        <div className='row input-row'>
                            <div className='col-md-12 projects-exited-details'>
                                <div className='col-md-8'>{t('Total ACCLIME Engagement Fee')}</div>
                                <div className='col-md-4 details'>{t('USD')} {formatNumber(TaxFilingQuestionnaire?.TotalTaxFilingFee)} {t('USD1')}</div>
                            </div>
                        </div>
                        <div className='row input-row'>
                            <div className='col-md-12 projects-exited-details'>
                                <div className='col-md-8'>{t('ACCLIME Fee deducted from Proceeds')}</div>
                                <div className='col-md-4 details'>({t('USD')} {formatNumber(TaxFilingQuestionnaire?.TotalTaxFilingFeeCollected)} {t('USD1')})</div>
                            </div>
                        </div>

                        <div className='row input-row engagement-fee' >
                            <div className='col-md-12 projects-exited-details'>
                                <div className='col-md-8'>{t('AAS Engagement Fee Shortfall')}</div>
                                <div className='col-md-4 details'>{t('USD')} {formatNumber(TaxFilingQuestionnaire?.TotalTaxFilingFeeShortfall)} {t('USD1')}</div>
                            </div>
                        </div>

                        <div className='row input-row tax-disclaimer'>
                            <div className='col-md-12'>
                                <p dangerouslySetInnerHTML={{ __html: taxDisclaimerNotes }} />
                            </div>
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className='row input-row'>
                            <div className='col-md-12 projects-exited-details'>
                                <span className='fee-title'>{t('Payment Method')}</span>
                            </div>
                        </div>

                        {
                            parseFloat(TaxFilingQuestionnaire.TotalTaxFilingFeeShortfall) <= 0 ? (<>
                                <div className='row input-row col-md-12' style={{ padding: "0 15px" }}>
                                    <div className='col-md-12 projects-exited-details payment'>
                                        <div className='col-md-12'>
                                            <div className='col-md-12 row input-row'>
                                                <div className='col-md-12 tax-filing-fees-icons'>
                                                    <svg
                                                        className="svg-circle"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="20"
                                                        height="20"
                                                        viewBox="0 0 20 20"
                                                        fill="none"
                                                    >
                                                        <path
                                                            d="M10 20C4.48674 20 0 15.5054 0 9.97817C0 4.45098 4.48674 0 10 0C15.5133 0 20 4.47756 20 9.97817C20 15.4788 15.5133 20 10 20ZM10 1.84493C5.50189 1.84493 1.84091 5.49302 1.84091 9.97817C1.84091 14.4633 5.50189 18.1551 10 18.1551C14.4981 18.1551 18.1591 14.488 18.1591 9.97817C18.1591 5.46835 14.5 1.84493 10 1.84493Z"
                                                            fill="#003448"
                                                        />
                                                    </svg>
                                                    <svg
                                                        className="svg-exclamation"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="2"
                                                        height="10"
                                                        viewBox="0 0 2 10"
                                                        fill="none"
                                                    >
                                                        <path
                                                            d="M0.918557 9.50633C0.412028 9.50633 0 9.09255 0 8.58387V4.72129C0 4.21261 0.412028 3.79883 0.918557 3.79883C1.42509 3.79883 1.83711 4.21261 1.83711 4.72129V8.58387C1.83711 9.09255 1.42509 9.50633 0.918557 9.50633Z"
                                                            fill="#003448"
                                                        />
                                                        <path
                                                            d="M0.918557 2.89808C0.412028 2.89808 0 2.4843 0 1.97561V1.41758C0 0.908897 0.412028 0.495117 0.918557 0.495117C1.42509 0.495117 1.83711 0.908897 1.83711 1.41758V1.97561C1.83711 2.4843 1.42509 2.89808 0.918557 2.89808Z"
                                                            fill="#003448"
                                                        />
                                                    </svg>
                                                </div>
                                                <div className='tax-filing-fees-notes'>
                                                    <span>
                                                        {t('You do not have any outstanding tax filing fees. Please click “Confirm” to proceed with the Tax Questionnaire submission.')}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>) : (<>
                                <div className='row input-row col-md-12' style={{ padding: "0 15px" }}>
                                    <img src={Image.paypal} alt='' className='banner-logo-paypal' />
                                    <div className='col-md-12 projects-exited-details payment'>
                                        <div className='col-md-12'>
                                            <div>
                                                <PayPalCheckoutButton TaxYear={TaxFilingQuestionnaire.TaxFilingYear} />
                                            </div>
                                            <div>
                                                <div className='payment-notes'>
                                                    <p>
                                                        <b>{t('IMPORTANT')}:</b>
                                                    </p>
                                                    <p>
                                                        {t('Paypal_Notes')}
                                                    </p>
                                                    <br />
                                                    <p className='amount'>
                                                        {t('Amount')}: {t('USD')} {TaxFilingQuestionnaire?.TotalPayPalAmount} {t('USD1')}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                {
                                    (user?.region === 'SG' || previewDetail?.regionCode === 'SG') && (<>
                                        <div className='row input-row col-md-12' style={{ textAlign: "center" }}>
                                            <p className='or'>{t('OR')}</p>
                                        </div>

                                        <div className='row input-row col-md-12' style={{ padding: "0 15px" }}>
                                            <img src={Image.payNow} alt='' className='banner-logo' />
                                            <div className='col-md-12 payment'>
                                                <div className='col-md-12 payment-buttons' >
                                                    <button onClick={handlePayNowModal}><img src={Image.payNow} alt='' className='paynow-logo' /></button>
                                                </div>
                                                <div className='payment-notes'>
                                                    <span>
                                                        {t('After clicking the PayNow button you will be redirected to a a new page to proceed.')}
                                                    </span>
                                                    <p>
                                                        {t('Please scan the QR code using your Bank’s PayNow App to make payment.')}
                                                    </p>
                                                    <br />
                                                    <p>{t('Paynow_Mobile_Notes')}</p>

                                                    <br />
                                                    <p>
                                                        <b>{t('IMPORTANT')}:</b>
                                                    </p>
                                                    <p>
                                                        {t('Before you pay, please ensure you check the details below are correct.')}
                                                    </p>
                                                    <br />
                                                    <p className='amount'>
                                                        {t('Payee Name')}: Walton Global Pte Ltd
                                                    </p>
                                                    <p className='amount'>
                                                        {t('Amount')}: {t('SGD')} {TaxFilingQuestionnaire?.TotalPayNowAmount}
                                                    </p>
                                                </div>
                                            </div>

                                        </div>
                                    </>)
                                }

                                {
                                    (bankTransferRegion.includes(user?.region) || bankTransferRegion.includes(previewDetail?.regionCode)) && (<>
                                        <div className='row input-row col-md-12' style={{ textAlign: "center" }}>
                                            <p className='or'>{t('OR')}</p>
                                        </div>
                                        <div className='row input-row col-md-12' style={{ padding: "0 15px" }}>
                                            <span className='banner-logo-bank'>{t('Bank Transfer')}</span>
                                            <div className='col-md-12 payment bank-transfer-notes'>
                                                <p dangerouslySetInnerHTML={{ __html: bankTransferNotes?.replaceAll('{taxFilingShortfall}', t('USD') + ' ' + formatNumber(TaxFilingQuestionnaire?.TotalBankTransferAmount) + ' ' + t('USD1')) }} />
                                            </div>

                                        </div>
                                    </>)
                                }
                            </>)
                        }
                    </div>
                </div>

                {
                    (!viewOnly && user?.sfUserType === 'CL') && (<>
                        <div className='row stepper-projects-exited-content col-md-12'>
                            <div className='input-row row'>
                                <p className='signature-title'>
                                    {t('Signature')} <i className='required'>*</i>
                                </p>
                                <p className='signature-title'>
                                    {t('Submission_Signature_Note')}
                                </p>
                            </div>
                            <div className='signature-container'>
                                <div className='signature-div'>
                                    <SignatureCanvas penColor='black' ref={signatureCanvasRef}
                                        canvasProps={{ className: 'sigCanvas' }} onEnd={handleEnd} />
                                </div>
                                <div className='clear-button-div'>
                                    <span className='btn ' onClick={handleClear}>{t('Clear')}</span>
                                </div>
                            </div>
                        </div>
                    </>)
                }
            </div>
        </>
    );
}
